"use strict";
import { config, errorOptions } from '../_config'
export const customerService = {
  loginAction,
  logoutAction,
  checkToken,
  getLoggedUserInfo,
  checkUserExists,
  validateRecaptcha,
  validateTurnstile,
  updatePhone,
  getBookingsByUser
}

async function checkUserExists (email) {
  const requestOptions = {
    method: 'POST',
    mode: 'cors',
    headers:{
      'Content-Type':'application/json; charset=UTF-8'
    },
    body: JSON.stringify({ email })
  }

  const rawResponse = await fetch(`${config.apiUrl}/usuarios/checkuser`,requestOptions)
    .catch(err => {
      toastr.options = errorOptions
      toastr["error"]("Error general. Por favor refresca la página.")
      console.log(err, toastr)
    })

  const content = await rawResponse.json().catch(err => {
    toastr.options = errorOptions
    toastr["error"]("Error general. Por favor refresca la página.")
    console.log(err, toastr)
  })
  const data = await content

  return data
}
async function loginAction( userData ){

  const requestOptions = {
    method: 'POST',
    mode: 'cors',
    headers:{
      'Content-Type':'application/json; charset=UTF-8'
    },
    body: JSON.stringify(userData)
  };

  const rawResponse = await fetch(`${config.apiUrl}/usuarios/login`,requestOptions)
    .catch(err => {
      toastr.options = errorOptions
      toastr["error"]("Error general. Por favor refresca la página.")
      console.log(err, toastr)
    })
  const content = await rawResponse.json().catch(err => {
    toastr.options = errorOptions
    toastr["error"]("Error general. Por favor refresca la página.")
    console.log(err, toastr)
  })
  const data = await content

  return data
}
async function getLoggedUserInfo() {
  const requestOptions = {
    method: 'POST',
    mode: 'cors',
    headers:{
      'Content-Type':'application/json; charset=UTF-8'
    }
  }

  const rawResponse = await fetch(`${config.apiUrl}/usuarios/getLoggedUserInfo`,requestOptions)
    .catch(err => {
      toastr.options = errorOptions
      toastr["error"]("Error general. Por favor refresca la página.")
      console.log(err, toastr)
    })
  const content = await rawResponse.json().catch(err => {
    toastr.options = errorOptions
    toastr["error"]("Error general. Por favor refresca la página.")
    console.log(err, toastr)
  })
  const data = await content

  return data
}
async function logoutAction() {
  const requestOptions = {
    method: 'POST',
    mode: 'cors',
    headers:{
      'Content-Type':'application/json; charset=UTF-8'
    }
  }


  const rawResponse = await fetch(`${config.apiUrl}/usuarios/logout`,requestOptions)
    .catch(err => {
      toastr.options = errorOptions
      toastr["error"]("Error general. Por favor refresca la página.")
      console.log(err, toastr)
    })
  const content = await rawResponse.json().catch(err => {
    toastr.options = errorOptions
    toastr["error"]("Error general. Por favor refresca la página.")
    console.log(err, toastr)
  })
  const data = await content

  return data
}
async function checkToken(tokenData) {
  const requestOptions = {
    method: 'POST',
    mode: 'cors',
    credentials:'include',
    headers:{
      'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'
    },
    body: `payload=${tokenData}`
  }

  const rawResponse = await fetch(`${config.apiUrl}/usuarios/checkToken`,requestOptions)
    .catch(err => {
      toastr.options = errorOptions
      toastr["error"]("Error general. Por favor refresca la página.")
      console.log(err, toastr)
    })

  const content = await rawResponse.json().catch(err => {
    toastr.options = errorOptions
    toastr["error"]("Error general. Por favor refresca la página.")
    console.log(err, toastr)
  })
  const data = await content

  return data
}

async function validateRecaptcha(recaptcha) {
  const requestOptions = {
    method: 'POST',
    mode: 'cors',
    credentials:'include',
    headers:{
      'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'
    },
    body: `recaptcha=${recaptcha}`
  }

  const rawResponse = await fetch(`${config.apiUrl}/usuarios/validateRecaptcha`,requestOptions)
    .catch(err => {
      toastr.options = errorOptions
      toastr["error"]("Error general. Por favor refresca la página.")
      console.log(err, toastr)
    })

  const content = await rawResponse.json().catch(err => {
    toastr.options = errorOptions
    toastr["error"]("Error general. Por favor refresca la página.")
    console.log(err, toastr)
  })
  const data = await content

  return data

}

async function validateTurnstile(token) {
  const requestOptions = {
    method: 'POST',
    mode: 'cors',
    credentials:'include',
    headers:{
      'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'
    },
    body: `recaptcha=${token}`
  }

  const rawResponse = await fetch(`${config.apiUrl}/usuarios/validateTurnstile`,requestOptions)
    .catch(err => {
      toastr.options = errorOptions
      toastr["error"]("Error general. Por favor refresca la página.")
      console.log(err, toastr)
    })

  const content = await rawResponse.json().catch(err => {
    toastr.options = errorOptions
    toastr["error"]("Error general. Por favor refresca la página.")
    console.log(err, toastr)
  })
  const data = await content

  return data

}


async function updatePhone(email, phone) {
  const requestOptions = {
    method: 'POST',
    mode: 'cors',
    credentials:'include',
    headers:{
      'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'
    },
    body: `user=${email}&phone=${phone}`
  }

  const rawResponse = await fetch(`${config.apiUrl}/usuarios/updatePhone`,requestOptions)
    .catch(err => {
      toastr.options = errorOptions
      toastr["error"]("Error general. Por favor refresca la página.")
      console.log(err, toastr)
    })

  const content = await rawResponse.json().catch(err => {
    toastr.options = errorOptions
    toastr["error"]("Error general. Por favor refresca la página.")
    console.log(err, toastr)
  })
  const data = await content

  return data

}

async function getBookingsByUser( email ) {

  
  const requestOptions = {
    method: 'POST',
    mode: 'cors',
    credentials:'include',
    headers:{
      'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'
    },
    body: `username=${email}`
  }

  const rawResponse = await fetch(`${config.apiUrl}/usuarios/getBookingsByUser`,requestOptions)
    .catch(err => {
      toastr.options = errorOptions
      toastr["error"]("Error general. Por favor refresca la página.")
      console.log(err, toastr)
    })

  const content = await rawResponse.json().catch(err => {
    toastr.options = errorOptions
    toastr["error"]("Error general. Por favor refresca la página.")
    console.log(err, toastr)
  })
  const data = await content

  return data

}



// WEBPACK FOOTER //
// ./src/_services/customer.service.js